/** CDN assets for the Performance Lab recovery page. */
export const PL_RECOVERY_PAGE_BASE = 'web_v2/performance-lab/recovery-page';

const RECOVERY_PAGE_ASSET_CACHE_VERSION = '?v=2';

const recoveryImageSrc = (path: string, width: number): string =>
  `${path}${RECOVERY_PAGE_ASSET_CACHE_VERSION}/w_${width}`;

export const RECOVERY_PAGE_HERO_POSTER = recoveryImageSrc(
  `${PL_RECOVERY_PAGE_BASE}/hero/hero-poster.png`,
  2048,
);

export const RECOVERY_PAGE_PARALLAX_BG = recoveryImageSrc(
  `${PL_RECOVERY_PAGE_BASE}/misc/parallax-banner.png`,
  2048,
);

export const RECOVERY_MARQUEE_BASE = `${PL_RECOVERY_PAGE_BASE}/marquee`;

export const RECOVERY_MARQUEE_FILENAMES = [
  'PL-9.jpg',
  'PL-8.jpg',
  '_TS_0513.jpg',
  'PL-15.jpg',
  '_TS_0704.jpg',
  'PL-12.jpg',
  'PL-13.jpg',
  'PL-11.jpg',
  '_TS_0310.jpg',
  'PL-10.jpg',
  '_TS_0241.jpg',
  '_TS_0494.jpg',
  'PL-19.png',
  '_TS_0382.jpg',
  '_TS_0360.jpg',
] as const;

export const RECOVERY_PASS_THUMBS: Record<string, string> = {
  'infrared-sauna': 'sauna.png',
  'cold-plunge': 'cold-plunge.png',
  decompression: 'inversions.png',
  'massage-guns': 'massage.png',
  powerplate: 'powerplate.png',
  compression: 'compression.png',
  'localized-hot-cold-therapy': 'hc-therapy.png',
};

export const recoveryMarqueeSrc = (
  filename: (typeof RECOVERY_MARQUEE_FILENAMES)[number],
): string => recoveryImageSrc(`${RECOVERY_MARQUEE_BASE}/${filename}`, 1080);

export const recoveryPassThumbSrc = (filename: string): string =>
  recoveryImageSrc(`${PL_RECOVERY_PAGE_BASE}/passes/${filename}`, 400);

export const RECOVERY_TREATMENT_THUMBS: Record<string, string> = {
  'hyperbaric-oxygen-therapy-hbot': 'hbot.png',
  cryotherapy: 'cryotherapy.png',
  'sports-massage': 'sport-massage.png',
  'iv-therapy': 'iv-therapy.png',
};

export const recoveryTreatmentThumbSrc = (filename: string): string =>
  recoveryImageSrc(`${PL_RECOVERY_PAGE_BASE}/plans/${filename}`, 520);
